function scrollToSection(event) {
    var target = event.target.closest('.js-anchor');
    if (target) {
        event.preventDefault();
        closePopupMobileMenu(target)
        var sectionId = target.getAttribute('href').slice(1);
        var selectedSection = document.querySelector("#".concat(sectionId));
        if (selectedSection) {
            window.scrollTo({
                top: selectedSection.offsetTop - 80,
                left: 0,
                behavior: "smooth"
            });
        }
    }
}
document.addEventListener('click', scrollToSection);
